import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { StylePreferencesService } from '../services/style-preferences.service';

@Directive({
  selector: '[orgbrainDebugInfo]',
    standalone: false
})
export class DebugDirective implements OnInit {
  private element = inject(ElementRef);
  private stylePreferences = inject(StylePreferencesService);


  ngOnInit() {
    const show = localStorage.getItem('debugDOM');
    const style = this.element.nativeElement.style;
    if (show) {
      style.display = 'block';
      style.color = 'red';
    } else {
      style.display = 'none';
    }
  }
}
